import { render, staticRenderFns } from "./park-region.vue?vue&type=template&id=1b185910&scoped=true&"
import script from "./park-region.vue?vue&type=script&lang=js&"
export * from "./park-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b185910",
  null
  
)

export default component.exports